import { WelfarePlan, useAuthStore } from '@tundr/auth';
import { CREDITS_ASSIGNMENT_WIZARD_NAMESPACE } from '../pages/CreditsAssignment/credits-assignment-wizard.ts';
import { CREDITS_IMPORT_WIZARD_NAMESPACE } from '../pages/CreditsImport/credits-import-wizard.ts';
import { creditsRoutesDictionary } from './credits-routes.dictionary';

export const creditsRoutesConfig = {
  ...creditsRoutesDictionary.credits.root,
  redirect: { name: creditsRoutesDictionary.credits.overview.name },
  beforeEnter: () => {
    const authStore = useAuthStore();
    return authStore.currentWelfarePlan === WelfarePlan.STANDARD;
  },
  children: [
    {
      ...creditsRoutesDictionary.credits.overview,
      component: () => import('../pages/CreditsOverview/CreditsOverview.vue'),
    },
    {
      ...creditsRoutesDictionary.credits.standardAssignmentFlow,
      meta: {
        wizardNamespace: CREDITS_ASSIGNMENT_WIZARD_NAMESPACE,
        wizardExitRoute: creditsRoutesDictionary.credits.overview.name,
      },
      component: () =>
        import('../pages/CreditsAssignment/CreditsAssignmentWizardPage.vue'),
    },
    {
      ...creditsRoutesDictionary.credits.importAssignmentFlow,
      meta: {
        wizardNamespace: CREDITS_IMPORT_WIZARD_NAMESPACE,
        wizardExitRoute: creditsRoutesDictionary.credits.overview.name,
      },
      component: () =>
        import('../pages/CreditsImport/CreditsImportWizardPage.vue'),
    },
    {
      ...creditsRoutesDictionary.credits.detail,
      component: () => import('../pages/OrderDetail/OrderDetail.vue'),
      props: true,
    },
  ],
};
